// Create namespace for theme functions
window.BoomBattleBarTheme = window.BoomBattleBarTheme || {};

// Create re-callable city selector init function for CMP compatibility
window.BoomBattleBarTheme.initCitySelector = function() {
    // Add idempotent flag
    if (window.BoomBattleBarTheme.citySelectorInitialized) {
        return;
    }

    /**
     * Default
     * 
     * Hide the modal on page load, unless clicked
     */
    $('.modal.modal--cities').hide();

    /**
     * When the .location-button clicked
     * Show the modal
     * 
     * This class is located next to main logo in the header
     */
    $(document).on( 'click', '.location-button', function(e){  
        $('.modal.modal--cities').show();
        $('body').addClass('app--modal');
    });

    /**
     * Close the modal when the X button is clicked
     * 
     * Located on the top right corner of the modal
     */
    $(document).on( 'click', '.modal__close', function(e){
        $('.modal.modal--cities').hide();
        $('body').removeClass('app--modal');
    });

    /**
     * Close the modal if the modal body is clicked
     * 
     * Anywhere as long as inside the modal wrapper
     */
    $(document).on( 'click', '.modal__body', function(e){
    //    $('.modal.modal--cities').hide();
    });

    $(document).on( 'click', '.tabbed-navigation__item', function(e){

        /**
         * Toogle the .city-navigation to display
         * the content of cities based on the continent selected
         */
        $('.city-navigation').each(function(){
            $(this).hide();
        });
        var getID = $(this).data('continent');
        $('.city-continent--' + getID).show();

        /**
         * Toogle .active
         * 
         * Go over siblings and remove, beofer adding to the current element
         */
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
    });

    window.BoomBattleBarTheme.citySelectorInitialized = true;
};

// Initialize immediately
jQuery(document).ready(window.BoomBattleBarTheme.initCitySelector);

// Re-init on Cookiebot consent
window.addEventListener('CookiebotOnAccept', window.BoomBattleBarTheme.initCitySelector, false);


// WEBPACK FOOTER //
// ./assets/js/helpers/city-selector.js